import { BCMSRecord, DisabledPrompt, useBCMSContext, useParams } from "@bcm-dev/bcms-vite";
import { TravelPlan, Trip } from "model";
import React from "react";

import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader, MainContentSection } from "components/shared/containers/MainContentContainer";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UICheckbox from "components/ui/UICheckbox";
import { SVGAsset } from "res";

import "./styles.css";
/**
 * @function TravelPlanPage
 * @return {React.Component}
 * @exported true
 * @description The main component for TravelPlanPage
 */

export default function TravelPlanPage(props) {
  const controller = useBCMSContext();
  const planID = useParams().planID ?? "0";

  BCMSRecord.globalControllerFor([ TravelPlan, Trip ], controller);

  const plan = TravelPlan.initByID(planID);
  const trip = Trip.initByID(plan.trip);

  return (
    <MainContentContainer className="travel-plan-page" header={<MainContentHeader text="Travel Plan" />}>
      <div className="framed-icon-container">
        <SVGAsset id="AirplaneIcon" />
      </div>

      <p className="text-center travel-plans-heading"><b>Travel Plan Details</b></p>

      <FormContainer>
        <MainContentSection text="Destinations">
          <TravelPlanLocations trip={ trip } />
        </MainContentSection>

        <MainContentSection text="Date of Departure">
          <FormRow className="date-row">
            <p>{ plan.departDate.format("M d, Y") }</p>
          </FormRow>
        </MainContentSection>
        
        <MainContentSection text="Date of Return">
          <FormRow className="date-row bottom-border">
            <p>{ plan.returnDate.format("M d, Y") }</p>
          </FormRow>
          <FormButtonContainer>
            <DisabledPrompt>
              <UIPrimaryButton text="Edit" />
            </DisabledPrompt>
            
            <DisabledPrompt>
              <UICancelButton text="Delete" />
            </DisabledPrompt>
          </FormButtonContainer>
        </MainContentSection>

      </FormContainer>
    </MainContentContainer>
  );
}

function TravelPlanLocations(props) {
  const trip = props.trip ?? Trip.firstInstanceOf();
  const locations = trip.destinationName.split(", ");

  const items = locations.map(name => {
    return (
      <FormRow>
        <UICheckbox label={ name } value={ true } />
      </FormRow>
    );
  }, []);

  return <>{ items }</>;
}